import { useQuery, type UseQueryResult } from '@tanstack/react-query'
import { proposalService } from '@/services/ProposalService'
import { proposalKeys } from '@/hooks/queryKeys'
import type { ProposalListDto } from '@lib/dto/proposal.dto'
import type { ListProposalsQuery } from '@lib/input/proposal.input'

/** Load proposals, optionally scoped to one client. */
export function useProposals(
  filters: Partial<ListProposalsQuery> = {},
): UseQueryResult<ProposalListDto> {
  return useQuery({
    queryKey: proposalKeys.list({
      clientId: filters.clientId,
      siteId: filters.siteId,
      search: filters.search,
      includeArchived: filters.includeArchived,
    }),
    queryFn: () => proposalService.list(filters),
    placeholderData: (previous) => previous,
    // Short, because a version's status changes with the clock: a sent proposal
    // becomes Expired on its own, with no mutation to invalidate the cache.
    staleTime: 15_000,
  })
}
